import React from 'react'
import { NavbarBorrowSystem } from "../../components/share/NavbarBorrowSystem";
import { HeadTitle } from "../../components/share/HeadTitle";
import { CreateBorrowFormComponent } from '../../components/Officer/CreateBorrowFormComponent'
import { Footer } from "../../components/share/Footer";
export const CreateBorrowFormContainer = () => {
  const titleName = "คำขอกู้ยืมเงินกองทุนพัฒนาฝีมือแรงงาน";

  return (
    <div className="page-container bg-landing">
      <NavbarBorrowSystem />
      <HeadTitle title={titleName} />
      <CreateBorrowFormComponent />
      <Footer />
    </div>
  )
}
